<p-card>
  <!-- Carga: la misma pantalla en gris. Lleva las clases reales (`detail-header`, `detail-card`,
       `info-grid`), así que la geometría sale de ahí y el reporte aterriza sin saltos. -->
  <div class="row" *ngIf="loading" aria-busy="true" aria-label="Cargando el detalle del reporte">
    <div class="col-12">
      <div class="detail-header">
        <div class="header-content">
          <p-skeleton height="1.6rem" width="16rem" styleClass="mb-2"></p-skeleton>
          <p-skeleton height="0.9rem" width="28rem"></p-skeleton>
        </div>
        <div class="header-actions">
          <p-skeleton height="2.5rem" width="7rem" borderRadius="6px"></p-skeleton>
          <p-skeleton height="2.5rem" width="8rem" borderRadius="6px"></p-skeleton>
        </div>
      </div>
    </div>
    <div class="col-12 col-lg-6" *ngFor="let c of [1, 2]">
      <p-card class="detail-card">
        <p-skeleton height="1.1rem" width="12rem" styleClass="mb-3"></p-skeleton>
        <div class="info-grid">
          <div class="info-item" *ngFor="let i of [1, 2, 3, 4]">
            <p-skeleton height="0.8rem" width="8rem"></p-skeleton>
            <p-skeleton height="0.95rem" width="11rem"></p-skeleton>
          </div>
        </div>
      </p-card>
    </div>
  </div>

  <div class="row" *ngIf="!loading && report">
    <div class="col-12">
      <div class="detail-header">
        <div class="header-content">
          <h1 class="mb-2">Detalles del Reporte</h1>
          <p class="mb-3 text-color-secondary">
            Información completa del corte de cartera generado el {{ report.createdAt | date:'dd/MM/yyyy HH:mm' }}
          </p>
        </div>
        <div class="header-actions">
          <button 
            pButton 
            type="button" 
            label="Volver" 
            icon="fa-solid fa-arrow-left"
            class="p-button-outlined"
            (click)="goBack()">
          </button>
          <button 
            pButton 
            type="button" 
            label="Descargar" 
            icon="fa-solid fa-download"
            class="p-button-success"
            [disabled]="downloading || report.status !== 'success' || !report.fileUrl"
            [loading]="downloading"
            (click)="downloadReport()">
          </button>
        </div>
      </div>
    </div>
    <p-toast></p-toast>
  </div>

  <div class="row" *ngIf="!loading && report">
    <!-- Información básica -->
    <div class="col-12 col-lg-6">
      <p-card header="Información General" class="detail-card">
        <div class="info-grid">
          <div class="info-item">
            <label>Fecha de Corte:</label>
            <span class="value">{{ (report.cutoffDate || report.fechaCorte) | date:'dd/MM/yyyy' }}</span>
          </div>
          
          <div class="info-item">
            <label>Estado:</label>
            <p-tag 
              [value]="getStatusLabel(report.status)" 
              [severity]="getStatusSeverity(report.status)">
            </p-tag>
          </div>

          <div class="info-item">
            <label>Generado por:</label>
            <span class="value">{{ (report.createdBy?.names || report.executedBy?.names || report.createdBy || 'N/A') + ' ' + (report.createdBy?.lastNames || report.executedBy?.lastNames || '') }}</span>
          </div>

          <div class="info-item">
            <label>Fecha de generación:</label>
            <span class="value">{{ (report.createdAt || report.generationDate) | date:'dd/MM/yyyy HH:mm' }}</span>
          </div>

          <div class="info-item" *ngIf="report.durationMs || (report.startTime && report.endTime)">
            <label>Tiempo de procesamiento:</label>
            <span class="value">{{ report.durationMs ? (report.durationMs + ' ms') : formatProcessingTime() }}</span>
          </div>

          <div class="info-item" *ngIf="report.type">
            <label>Tipo de corte:</label>
            <span class="value">{{ report.type }}</span>
          </div>
        </div>
      </p-card>
    </div>

    <!-- Información del archivo -->
    <div class="col-12 col-lg-6">
      <p-card header="Información del Archivo" class="detail-card">
        <div class="info-grid">
          <div class="info-item" *ngIf="report.fileName">
            <label>Nombre del archivo:</label>
            <span class="value">{{ report.fileName }}</span>
          </div>

          <div class="info-item" *ngIf="report.fileSize">
            <label>Tamaño del archivo:</label>
            <span class="value">{{ formatFileSize(report.fileSize) }}</span>
          </div>

          <div class="info-item" *ngIf="report.fileFormat">
            <label>Formato:</label>
            <span class="value">{{ report.fileFormat }}</span>
          </div>

          <div class="info-item">
            <label>Número de registros:</label>
            <span class="value">{{ (report.recordCount || report.records || 0) | number }}</span>
          </div>

          <div class="info-item" *ngIf="report.fileUrl && report.status === 'success' && report.expirationDate">
            <label>Disponible hasta:</label>
            <span class="value">{{ report.expirationDate | date:'dd/MM/yyyy HH:mm' }}</span>
          </div>

          <div class="info-item" *ngIf="report.downloadCount">
            <label>Descargas:</label>
            <span class="value">{{ report.downloadCount }}</span>
          </div>
        </div>
      </p-card>
    </div>

    <!-- Información de emails -->
    <div class="col-12" *ngIf="(report.emails || report.recipients) && (report.emails?.length > 0 || report.recipients?.length > 0)">
      <p-card header="Destinatarios de Email" class="detail-card">
        <div class="email-list">
          <div class="email-item" *ngFor="let email of (report.emails || report.recipients)">
            <i class="fa-solid fa-envelope email-icon"></i>
            <span class="email-address">{{ email }}</span>
          </div>
        </div>
        <div class="email-summary">
          <small class="text-600">
            Total: {{ (report.emails || report.recipients)?.length }} destinatario(s)
            <span *ngIf="report.emailsSent"> | Enviados: {{ report.emailsSent }}</span>
          </small>
        </div>
      </p-card>
    </div>

    <!-- Log de procesamiento -->
    <div class="col-12" *ngIf="report.processingLog && report.processingLog.length > 0">
      <p-card header="Log de Procesamiento" class="detail-card">
        <p-timeline [value]="report.processingLog" layout="vertical">
          <ng-template pTemplate="content" let-event>
            <div class="timeline-event">
              <h6>{{ event.step }}</h6>
              <p class="timeline-description">{{ event.description }}</p>
              <small class="timeline-time">{{ event.timestamp | date:'HH:mm:ss' }}</small>
            </div>
          </ng-template>
        </p-timeline>
      </p-card>
    </div>

    <!-- Información de error -->
    <div class="col-12" *ngIf="report.status === 'failed' && report.errorDetails">
      <p-card header="Detalles del Error" class="detail-card error-card">
        <div class="error-content">
          <div class="error-message">
            <i class="fa-solid fa-exclamation-triangle error-icon"></i>
            <div>
              <h6>{{ report.errorDetails.message || 'Error durante el procesamiento' }}</h6>
              <p *ngIf="report.errorDetails.code">Código de error: {{ report.errorDetails.code }}</p>
            </div>
          </div>
          
          <div class="error-details" *ngIf="report.errorDetails.stack">
            <div class="error-stack-container">
              <h6>Detalles técnicos:</h6>
              <pre class="error-stack">{{ report.errorDetails.stack }}</pre>
            </div>
          </div>
        </div>
      </p-card>
    </div>

    <!-- Métricas del reporte -->
    <div class="col-12" *ngIf="report.metrics">
      <p-card header="Métricas del Reporte" class="detail-card">
        <div class="metrics-grid">
          <div class="metric-item" *ngIf="report.metrics.totalAmount">
            <h4>{{ report.metrics.totalAmount | currency }}</h4>
            <p>Monto total de cartera</p>
          </div>
          
          <div class="metric-item" *ngIf="report.metrics.activeLeases">
            <h4>{{ report.metrics.activeLeases | number }}</h4>
            <p>Arrendamientos activos</p>
          </div>
          
          <div class="metric-item" *ngIf="report.metrics.overdueAmount">
            <h4>{{ report.metrics.overdueAmount | currency }}</h4>
            <p>Monto vencido</p>
          </div>
          
          <div class="metric-item" *ngIf="report.metrics.collectableAmount">
            <h4>{{ report.metrics.collectableAmount | currency }}</h4>
            <p>Por cobrar</p>
          </div>
        </div>
      </p-card>
    </div>
  </div>

  <!-- Mensaje cuando no hay reporte -->
  <div class="row" *ngIf="!loading && !report">
    <div class="col-12">
      <div class="text-center">
        <i class="fa-solid fa-file-excel error-icon large-icon"></i>
        <h3>Reporte no encontrado</h3>
        <p>El reporte solicitado no existe o no tienes permisos para verlo.</p>
        <button 
          pButton 
          type="button" 
          label="Volver al listado" 
          icon="fa-solid fa-arrow-left"
          (click)="goBack()">
        </button>
      </div>
    </div>
  </div>
</p-card>